const theme = {
  '--background': '#1A1818',

  '--primary': '#0CF10C',
  '--primary-dark-1': '#0CF10C',
  '--primary-dark-2': '#0CF10C',
  '--primary-light-1': '#0CF10C',
  '--primary-light-2': '#0CF10C',

  '--secondary': '#184F17',
  '--secondary-transparent': '#184F17',
  '--secondary-dark-1': '#184F17',
  '--secondary-dark-2': '#184F17',
  '--secondary-light-1': '#184F17',
  '--secondary-light-2': '#184F17',

  '--neutral': '#21B404',
  '--neutral-dark-1': '#21B404',
  '--neutral-dark-2': '#21B404',
  '--neutral-dark-3': '#21B404',
  '--neutral-light-1': '#20A406',
  '--neutral-light-2': '#1F9508',
  '--neutral-light-3': '#1F850A',
  '--neutral-light-4': '#1D660E',
  '--neutral-light-5': '#1D5E0F',
  '--neutral-light-6': '#1C5610',
  '--neutral-light-7': '#1B3714',
  '--neutral-light-8': '#1A2F15',
  '--neutral-light-9': '#202A1D',
  '--neutral-light-10': '#1D211B ',
  '--white': '#1F211F',
  '--darkmode-static-white': 'var(--white)',

  '--page-header-gradient':
    'linear-gradient(323.08deg, #4FF069 36.13%, #09BD51 133.51%)',
  '--page-header-gradient-color-1': 'var(--neutral-light-10)',
  '--page-header-gradient-color-2': 'var(--neutral-light-10)',

  '--tile-shadow-1': 'rgba(0, 0, 0, 0.1)',
  '--tile-shadow-2': '#000000',
  '--tile-shadow-3': 'rgba(0,0,0, 0.25)',
  '--tile-shadow-1-alt': 'rgba(17,17,34,0.2)',

  '--currently-playing-border': 'none',
  '--currently-playing-default-shadow': 'rgba(17, 17, 17, 0.1)',

  '--card-image-shadow': 'rgba(17,17,17,.25)',

  '--search-bar-background': 'var(--neutral-light-9)',
  '--search-bar-expanded': 'var(--neutral-light-9)',
  '--search-bar-border': 'rgba(143,149,152,0.1)',
  '--search-bar-shadow': 'rgba(36,36,56,0.2)',

  '--nav-column-group-header': 'var(--neutral-light-6)',
  '--nav-column-link': 'var(--neutral-light-2)',
  '--nav-column-link-hover': 'var(--neutral-light-1)',

  '--slider-handle': 'var(--neutral-dark-2)',

  '--table-shadow': 'rgba(17, 17, 34, 0.15)',

  '--mask': 'rgba(36, 36, 52, .7)',
  '--skeleton-gradient':
    'linear-gradient(90deg, #393A54 25%, #35364F 37%, #393A54 63%)',
  '--skeleton': 'var(--neutral-light-7)',
  '--profile-completion-shadow-1': 'rgba(0,0,0,0)',
  '--profile-completion-shadow-2': 'rgba(17, 17, 34, 0.15)',

  '--default-profile-picture-background': 'var(--neutral-light-6)',

  '--notification-panel-box-shadow': 'rgba(0,0,0,0.25)',
  '--notification-border': 'var(--neutral-light-7)',
  '--notification-background': 'var(--white)',
  '--notification-border-hover': 'var(--neutral-light-8)',
  '--notification-background-hover': 'var(--neutral-light-9)',
  '--notification-background-box-shadow': '0 2px 15px -4px rgba(17,17,34,0.2)',
  '--notification-border-active': 'var(--neutral-light-8)',
  '--notification-background-active': 'var(--white)',

  '--notification-unread-border': 'var(--neutral-light-8)',
  '--notification-unread-background': '--var(--neutral-light-8)',
  '--notification-unread-border-hover': 'var(--neutral-light-6)',
  '--notification-unread-background-hover': 'var(--neutral-light-7)',
  '--notification-unread-background-box-shadow': 'none',
  '--notification-unread-border-active': 'var(--neutral-light-8)',
  '--notification-unread-background-active': '--var(--white)',

  '--page-header-gradient-1': 'var(--neutral-light-10)',
  '--page-header-gradient-2': 'var(--neutral-light-10)',
  '--page-header-gradient-2-alt': 'var(--neutral-light-10)',
  '--page-header-text-shadow-color': 'rgba(20, 255, 0, 0.25)',
  '--page-header-text-shadow':
    '0px 0px 5px rgba(225, 255, 234, 0.25), 0px 0px 15px var(--page-header-text-shadow-color)',

  '--primary-gradient':
    'linear-gradient(135deg, var(--primary) 0%, var(--primary) 100%)',
  '--primary-gradient-alt-1': 'var(--primary-gradient)',
  '--next-and-previous-buttons': 'var(--neutral-light-4)',
  '--secondary-gradient': 'linear-gradient(0deg, #2F8B27 0%, #00FF29 95.45%)',
  '--segmented-progress-bar-segment-1': 'var(--secondary-gradient)',
  '--segmented-progress-bar-segment-2': 'var(--secondary-gradient)',
  '--segmented-progress-bar-segment-3': 'var(--secondary-gradient)',
  '--segmented-progress-bar-segment-4': 'var(--secondary-gradient)',
  '--segmented-progress-bar-segment-5': 'var(--secondary-gradient)',
  '--segmented-progress-bar-segment-6': 'var(--secondary-gradient)',
  '--segmented-progress-bar-segment-7': 'var(--secondary-gradient)',
  '--play-button-triangle': 'var(--white)',
  '--action-sheet-text': 'var(--neutral)',
  '--track-slider-rail':
    'linear-gradient(294.99deg, #4FF069 -8.52%, #09BD51 118.66%)',
  '--track-slider-handle':
    'linear-gradient(323.08deg, #4FF069 36.13%, #09BD51 133.51%)',
  '--stat-tile-text': 'var(--secondary-dark-1)'
}

export default theme
